import { format } from 'date-fns';
import { DEFAULT_DATE_FORMAT, DEFAULT_DATE_TIME_FORMAT } from '@/utils/dates';
import { Task } from './types';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { CheckIcon, Cross2Icon } from '@radix-ui/react-icons';
import { ProcessObject } from '@/routes/process-objects/list/types';
import { TaskType } from '../types';

export type CalibrationTaskDetailsProps = {
	task: Task;
};

const PoList = ({ items }: { items: ProcessObject[] }) => {
	return (
		<Table className="text-xs w-full">
			<TableHeader className="border-b-1">
				<TableRow>
					<TableHead>PO ID</TableHead>
					<TableHead>PO Name</TableHead>
					<TableHead>Primary TTMS ID</TableHead>
					<TableHead>Algorithm</TableHead>
				</TableRow>
			</TableHeader>
			<TableBody>
				{items.length === 0 && (
					<TableRow>
						<TableCell colSpan={10} className="text-center pt-10">
							No process objects available
						</TableCell>
					</TableRow>
				)}
				{items.map(po => (
					<TableRow key={po.id}>
						<TableCell>{po.id}</TableCell>
						<TableCell>{po.name}</TableCell>
						<TableCell>{po.ttmsIdPrimary}</TableCell>
						<TableCell>{po.algorithm}</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	);
};

const CalibrationTaskDetails = ({ task }: CalibrationTaskDetailsProps) => {
	return (
		<div className="grid lg:grid-cols-[40%_58%] grid-cols-1 gap-4 text-xs mb-3">
			<div className="flex flex-col space-y-4">
				<div className="flex gap-2">
					<span className="font-bold">Task Id: </span>
					<span>{task.id}</span>
				</div>
				<div className="flex gap-10">
					<div className="flex flex-col gap-2">
						<span className="font-bold">Task start time</span>
						<span>
							{task.taskStartTime
								? format(new Date(task.taskStartTime), DEFAULT_DATE_TIME_FORMAT)
								: 'N/A'}
						</span>
					</div>
					<div className="flex flex-col gap-2">
						<span className="font-bold">Task end time</span>
						<span>
							{task.taskEndTime ? format(new Date(task.taskEndTime), DEFAULT_DATE_TIME_FORMAT) : 'N/A'}
						</span>
					</div>
					<div className="flex flex-col gap-2">
						<span className="font-bold">Last updated</span>
						<span>
							{task.statusLastUpdateTime
								? format(new Date(task.statusLastUpdateTime), DEFAULT_DATE_TIME_FORMAT)
								: 'N/A'}
						</span>
					</div>
				</div>
				{task.type != TaskType.REVISION_DATA && <div className="flex flex-col space-y-2">
					<p className="font-bold">Calibration operation dates</p>
					<div className="flex gap-10">
						<p className="flex gap-2">
							<span className="font-bold">From</span>
							{format(new Date(task.dataStartTime), DEFAULT_DATE_FORMAT)}
						</p>
						<p className="flex gap-2">
							<span className="font-bold">To</span>
							{format(new Date(task.dataEndTime), DEFAULT_DATE_FORMAT)}
						</p>
					</div>
					<div className="flex gap-10">
						<div className="flex items-center space-x-2">
							{task.metadata.intercept ? (
								<CheckIcon className="w-4 h-4 text-slate-900 dark:text-slate-100" />
							) : (
								<Cross2Icon className="w-4 h-4 text-slate-900 dark:text-slate-100" />
							)}
							<span className="font-medium">Intercept</span>
						</div>
					</div>
				</div>}
			</div>
			{task.type != TaskType.REVISION_DATA && <div className="w-full rounded-md border">
				<PoList items={task.metadata.processObjects} />
			</div>} 
		</div>
	);
};

export default CalibrationTaskDetails;
